<template class="Modal">
  <a-button
    block
    :id="`portfolio-assign-users-button-${index}`"
    class="table-cell__actions-btn"
    type="text"
    @click="handleShowModal"
  >
    <template #icon>
      <UserAddOutlined
        :style="{
          fontSize: '16px',
        }"
      />
    </template>
    <p>
      <span v-if="record.num_agents > 0">Editar usuarios</span>
      <span v-else>Agregar usuarios</span>
    </p>
  </a-button>
  <div>
    <a class="link--edit" @click="handleShowModal">
      {{ text }}
    </a>
    <a-modal
      :visible="visible"
      width="750px"
      :body-style="bodyStyle"
      :title="modalTitle"
      :mask-closable="false"
      centered
      :keyboard="false"
      wrapClassName="portfolio-assign-users-modal"
      @cancel="handleConfirmationClose"
    >
      <!-- {{ record.name }} -->
      <div>
        <p>Seleccionar a los usuarios que desees agregar a esta campaña.</p>
      </div>
      <UserProfileCheckList :record="record" v-if="visible" />

      <!--Fotter Modal -->
      <template v-slot:footer>
        <a-button key="back" @click="handleCancel"> Cancelar </a-button>
        <a-button
          id="save-portfolio-assigned-users"
          key="submit"
          type="primary"
          @click="handleSaveForm"
        >
          {{ nameUser }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { QuestionCircleOutlined, UserAddOutlined } from "@ant-design/icons-vue";
import { defineComponent, createVNode } from "vue";
import UserProfileCheckList from "@/app/shared/components/sections/UserProfileCheckList.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    UserProfileCheckList,
    UserAddOutlined,
  },
  props: {
    text: {
      required: false,
      default: "",
      type: String,
    },
    record: {
      type: Object,
      required: true,
    },
    index: Number,
  },
  data() {
    return {
      visible: false,
      bodyStyle: {
        padding: "20px 50px 0",
      },
    };
  },
  computed: {
    nameUser() {
      return this.record.users_assigned.length > 0 ? "Guardar cambios" : "Agregar";
    },
    modalTitle() {
      const userName = this.capitalizeFirstLetter(this.record.name);
      return this.record.users_assigned.length > 0
        ? `Editar usuarios - "${userName}"`
        : "Agregar usuarios";
    },
  },
  methods: {
    async handleSaveForm() {
      await this.$store.dispatch("addUsersProfilePortfolio", {
        portfolioId: this.record.id,
      });

      this.visible = false;
    },
    async handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    confirmationUncheckUser() {
      if (this.record.users_assigned.length > 0) {
        Modal.confirm({
          title: "¿Estás seguro de quitar usuarios de esta campaña? ",
          content:
            "Recuerda que también dejarán de visualizarse en las estrategias y colas asociadas a esta campaña.",
          icon: createVNode(QuestionCircleOutlined),
          okText: "Quitar",
          calcelText: "Cancelar",
          onOk: () => this.handleSaveForm(),
          centered: true,
        });
      } else {
        this.handleSaveForm();
      }
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de cerrar el proceso?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Sí, descartar cambios",
        cancelText: "No, seguir editando",
      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
});
</script>
<style lang="sass" scoped>
@import '@/app/shared/assets/table-cell-actions.sass'
</style>
